import qs from "query-string";
import type { MaybePromise } from "@reduxjs/toolkit/dist/query/tsHelpers";
import { createApi, BaseQueryApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

declare const process: { env: { [key: string]: string } };

//* Remove token for code
export const token = process.env.REACT_APP_TOKEN || "";
const xsrfToken: any =
  process.env.NODE_ENV === "production" && document.getElementById("csrf-token")
    ? document.getElementById("csrf-token")?.getAttribute("content")
    : "X-XSRF-TOKEN";
const xsrfTokenHeader: any =
  process.env.NODE_ENV === "production" && document.getElementById("csrf-token")
    ? document.getElementById("csrf-header")?.getAttribute("content")
    : "X-XSRF-TOKEN";

type PickProps = "getState" | "extra" | "endpoint" | "type" | "forced";

const prepareHeaders = (
  headers: Headers,
  { getState }: Pick<BaseQueryApi, PickProps>,
): MaybePromise<void | Headers> | undefined => {
  headers.set("X-Interswitch-Authorization-Domain", "ISW");

  if (headers.get("content-type") === null) {
    headers.set("content-type", "application/json");
  }

  if (headers.get("content-type") === "*") {
    headers.delete("content-type");
  }

  if (process.env.NODE_ENV !== "production") {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (process.env.NODE_ENV === "production") {
    headers.set("xsrfToken", xsrfToken);
    headers.set("X-XSRF-TOKEN", xsrfToken);
    headers.set("xsrfTokenHeader", xsrfTokenHeader);
  }

  return headers;
};

// ? initialize an empty api service that we'll inject endpoints into later as needed
export const neftApi = createApi({
  reducerPath: "neftApiSlice",
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
    baseUrl: "/neft_service/api/v1",
    paramsSerializer: (params) => qs.stringify(params),
  }),
  keepUnusedDataFor: 3000,
  endpoints: () => ({}),
});
